import React from 'react';

const SectionTitle = ({ title, description, textAlign }) => (
    <div className={`section-title ${textAlign || ''}`}>
        <h2 className="title w-600 mb--20" dangerouslySetInnerHTML={{ __html: title }}></h2>
        {description ? <p className="description b1" dangerouslySetInnerHTML={{ __html: description }}></p> : null}
    </div>
);

export default SectionTitle;
